var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    staticClass: "lang-modal",
    attrs: {
      title: (_vm.isEdit ? _vm.$t("编辑") : _vm.$t("添加")) + _vm.$t("标签"),
      visible: _vm.visible,
      width: 600
    },
    on: {
      cancel: e => _vm.closeAddVisible(e)
    }
  }, [_c("a-form-model", {
    ref: "addFormRef",
    attrs: {
      model: _vm.addForm,
      rules: _vm.ADD_RULES,
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("标签名称"),
      prop: "signName"
    }
  }, [_vm.isEdit ? _c("span", [_vm._v(_vm._s(_vm.addForm.signName))]) : _c("a-input", {
    attrs: {
      allowClear: ""
    },
    model: {
      value: _vm.addForm.signName,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "signName", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "addForm.signName"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: "简体中文",
      prop: "zh"
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: ""
    },
    model: {
      value: _vm.addForm.zh,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "zh", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "addForm.zh"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: "繁體中文",
      prop: "cht"
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: ""
    },
    model: {
      value: _vm.addForm.cht,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "cht", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "addForm.cht"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: "English",
      prop: "en"
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: ""
    },
    model: {
      value: _vm.addForm.en,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "en", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "addForm.en"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: "Français",
      prop: "fra"
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: ""
    },
    model: {
      value: _vm.addForm.fra,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "fra", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "addForm.fra"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: "español",
      prop: "spa"
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: ""
    },
    model: {
      value: _vm.addForm.spa,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "spa", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "addForm.spa"
    }
  })], 1)], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    staticStyle: {
      width: "60px"
    },
    attrs: {
      type: "primary",
      size: "small"
    },
    on: {
      click: _vm.saveAdd
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("保存")) + " ")]), _c("a-button", {
    staticStyle: {
      width: "60px"
    },
    attrs: {
      size: "small"
    },
    on: {
      click: _vm.closeAddVisible
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("取消")) + " ")])], 1)], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };